import React, { useRef, useState } from 'react';
import { EnvelopeIcon, MapPinIcon, PhoneIcon } from '@heroicons/react/24/solid';
import emailjs from '@emailjs/browser';
import { toast } from 'react-toastify';

const Contact = ({ email, phoneNumber }) => {
  const form = useRef();
  const phoneRef = useRef(null);
  const emailRef = useRef(null);
  const handlePhoneNumber = (e) => {
    const content = phoneRef.current.textContent;
    navigator.clipboard
      .writeText(content)
      .then(() => toast.success('Number Copied!'))
      .catch((err) => console.error('Error copying text: ', err));
  };
  const handleEmail = (e) => {
    const content = emailRef.current.textContent;
    navigator.clipboard
      .writeText(content)
      .then(() => toast.success('Email Copied!'))
      .catch((err) => console.error('Error copying text: ', err));
  };
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_c2auqig',
        'template_gc3296i',
        form.current,
        'eGqyExGM6KFPreaJS'
      )
      .then(
        (result) => {
          console.log(result.text);
          toast.success('Sent! Thanks for contacting.');
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="relative h-screen flex flex-col text-center md:text-left md:flex-row  px-10 justify-evenly mx-auto items-center">
      <h3 className="absolute mt-6 text-center top-0 uppercase tracking-[20px] text-gray-500">
        Contact
      </h3>
      <div className="flex flex-col items-center space-y-8 md:space-x-7">
        <h4 className=" md:mt-11  text-[16px] md:text-xl tracking-widest font-semibold text-center">
          I&apos;ve Got What You <span className="text-[#5bccf6]">Need</span>
          ,Let&apos;s Talk!
        </h4>
        <div className=" px-24 space-y-8 md:space-y-7">
          <div className="flex group hover:cursor-pointer items-center space-between space-x-3 md:space-x-5">
            <PhoneIcon className="text-[#5bccf6] h-7 -w-7 animate-pulse" />
            <p
              ref={phoneRef}
              onClick={handlePhoneNumber}
              className="tracking-widest hover:text-[#5bccf6] transition-all duration-300 text-base md:text-2xl"
            >
              {phoneNumber}
            </p>
          </div>
          <div className="flex group hover:cursor-pointer items-center space-between space-x-3 md:space-x-5">
            <EnvelopeIcon className="text-[#5bccf6] h-7 -w-7 animate-pulse" />
            <p
              ref={emailRef}
              onClick={handleEmail}
              className="tracking-widest text-base md:text-2xl hover:text-[#5bccf6] transition-all duration-300"
            >
              {email}
            </p>
          </div>
          <div className="flex items-center space-between space-x-3 md:space-x-5">
            <MapPinIcon className="text-[#5bccf6] h-7 -w-7 animate-pulse" />
            <p className="tracking-widest text-base md:text-2xl">
              Nairobi,Kenya.
            </p>
          </div>
        </div>
        <form
          ref={form}
          onSubmit={sendEmail}
          className="flex flex-col space-y-3 md:space-y-2 px-16 md:px-0  w-fit mx-auto"
        >
          <div className="flex w-[95%] mx-auto md:w-full  space-x-2">
            <input
              name="from_name"
              required
              placeholder="First Name"
              className="contactInput"
              type="text"
            />
            <input
              name="user_email"
              required
              placeholder="example@gmail.com"
              className="contactInput"
              type="email"
            />
          </div>
          <input
            name="subject"
            placeholder="Suject"
            required
            className="contactInput"
            type="text"
          />
          <textarea
            name="message"
            required
            placeholder="Message"
            className="contactInput"
          />
          <input type="hidden" name="to_name" value="Jackon Echesa" />
          <button
            type="submit"
            className="bg-[#5bccf6] z-50 hover:bg-[#17ade4] active:scale-105 mx-auto py-2 w-[95%] md:w-full md:py-5 px-10 rounded-md text-black font-bold transition-all duration-300"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
